import React from "react";

const IconDownload = ({ color = "#e31c19" }) => {
  return (
    <svg
      id="UI_icon_download_light"
      data-name="UI icon/download/light"
      xmlns="http://www.w3.org/2000/svg"
      width="17.1"
      height="15.2"
      viewBox="0 0 17.1 15.2"
    >
      <path
        id="Union"
        d="M6.175.95a.95.95,0,1,0-1.9,0V8.632L1.622,5.979A.95.95,0,1,0,.278,7.322l3.6,3.6a1.9,1.9,0,0,0,2.687,0l3.6-3.6A.95.95,0,0,0,8.826,5.98L6.175,8.632Z"
        transform="translate(3.327)"
        fill={color}
      />
      <path
        id="Path_13_Copy_5_Stroke_"
        data-name="Path 13 Copy 5 (Stroke)"
        d="M.95,0A.95.95,0,0,1,1.9.95v1.9a.95.95,0,0,0,.95.95h11.4a.95.95,0,0,0,.95-.95V.95a.95.95,0,0,1,1.9,0v1.9A2.85,2.85,0,0,1,14.25,5.7H2.85A2.85,2.85,0,0,1,0,2.85V.95A.95.95,0,0,1,.95,0Z"
        transform="translate(0 9.5)"
        fill={color}
      />
    </svg>
  );
};

export default IconDownload;
